import { SET_NUMBER_OF_GUESTS_FOR_SWIMMING } from '../constants/swimming';

export const setNumberOfGuestsForSwimming = numOfGuests => ({ // eslint-disable-line
  type: SET_NUMBER_OF_GUESTS_FOR_SWIMMING,
  numOfGuests,
});
